import axios from "axios";
import { useQuery } from "react-query";

export const createQuiz = async (quiz: any) => {
  const headers = {
    "Access-Control-Expose-Headers": "Access-Control-Allow-Origin",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const data = {
    TableName: "quizzes",
    Item: quiz,
  };
  await axios
    .post("https://d222hu8pcowl39.cloudfront.net/default/querying", data, {
      headers,
    })
    .catch((e) => console.log(e));
};

export const selectQuiz = async (quizId: string) => {
  const url = 'https://d3cjpq8gaw2knx.cloudfront.net/quizzes/' + quizId;
  const headers = {
    "Access-Control-Expose-Headers": "Access-Control-Allow-Origin",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  return await axios.get(url);
}

export const useQuizQuery = (quizId: string) => {
  return useQuery(['quiz', quizId], () => selectQuiz(quizId), {
    refetchOnWindowFocus: false
  });
};